import { render, staticRenderFns } from "./sentiment.vue?vue&type=template&id=521f0446&"
import script from "./sentiment.vue?vue&type=script&lang=js&"
export * from "./sentiment.vue?vue&type=script&lang=js&"
import style0 from "./sentiment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports